module.exports = __webpack_public_path__ + "static/media/MIddlepart_graphic_left.f03a625b.svg";